import { useEffect, useMemo } from "react";
import BackArrow from "../../components/BackArrow";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../helpers/constants";
import { AppButton, DataNotFound } from "../../components";
import { insertRestaurantDetailsInDB } from "./DBQuery";
import { reqToGetRestaurantDetailsFromIDB } from "../../store/slice/indexedDBSlice";
import { checkIsValidArray } from "../../helpers/commonFunction";

const CompanyItemDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    type,
    showUpload,
    selectedItem,
    selectedLocation,
    selectedRestaurant,
  } = location.state || {};

  useEffect(() => {
    if (!selectedItem || !selectedItem?.id) {
      navigate(routes.dashboard);
    }
  }, []);

  const { restaurantList, govermentMarketList, isRestaurantListIDBChecked } =
    useSelector(
      (state) => ({
        restaurantList: state.indexedDBReducer?.restaurantList,
        govermentMarketList: state.indexedDBReducer?.govermentMarketList,
        isRestaurantListIDBChecked:
          state.indexedDBReducer?.isRestaurantListIDBChecked,
      }),
      shallowEqual
    );

  useEffect(() => {
    if (!isRestaurantListIDBChecked) {
      dispatch(reqToGetRestaurantDetailsFromIDB({}));
    }
  }, [restaurantList, govermentMarketList, isRestaurantListIDBChecked]);

  // CURRENT SELECTED RESTAURANT
  const currSRestaurant = useMemo(() => {
    const newRestaurantList =
      type === "COMPANY" || type === "cReports"
        ? restaurantList
        : govermentMarketList;

    if (!checkIsValidArray(newRestaurantList)) {
      return selectedRestaurant;
    }

    const sRestaurant = newRestaurantList.find(
      (item) => item.id === selectedRestaurant.id
    );
    return sRestaurant || selectedRestaurant;
  }, [restaurantList, govermentMarketList]);

  // CURRENT SELECTED ITEM
  const currSItem = useMemo(() => {
    if (!currSRestaurant || currSRestaurant?.location?.length === 0) {
      return selectedItem;
    }

    const currResItem = currSRestaurant?.location.find(
      (loc) => loc.name === selectedLocation
    );
    if (!currResItem || currResItem?.items?.length === 0) return selectedItem;

    const currResSItem = currResItem?.items.find(
      (sub) => sub.id === selectedItem.id
    );
    return currResSItem || selectedItem;
  }, [currSRestaurant]);

  // CURRENT SELECTED SUB ITEM (SIPHONING)
  const currSubItem = useMemo(() => {
    if (
      Array.isArray(currSItem?.sub_items) &&
      currSItem?.sub_items?.length > 0
    ) {
      const findSiphoning = currSItem?.sub_items?.find(
        (item) => item?.name === "SIPHONING" && item?.item_report?.length === 0
      );
      return findSiphoning || null;
    } else {
      return null;
    }
  }, [currSItem]);

  const handleSkipSiphoning = async () => {
    try {
      const reqObj = {
        sub_item_id: currSubItem?.id,
        user_id: currSRestaurant?.id,
        image: null,
        base64: null,
        record_date: new Date(),
        status: "skip",
      };

      const reqObjFinal = {
        reqObj: reqObj,
        currSItem: currSItem,
        currSubItem: currSubItem,
        currSRestaurant: currSRestaurant,
        selectedLocation: selectedLocation,
      };

      await insertRestaurantDetailsInDB(reqObjFinal, dispatch, type);
    } catch (error) {}
  };

  return (
    <div className="tcl-raffles-makati-page tcl-raffles-makati-details-page">
      <div className="tcl-raffles-makati-wrapper">
        <BackArrow
          handleClick={() =>
            navigate(routes.companyItemList, { state: { ...location.state } })
          }
        />
        <div className="tcl-raffles-makati-text">
          <h2>
            <b>
              {currSItem?.name} - {selectedLocation}
            </b>
          </h2>
        </div>
        {!Array.isArray(currSItem?.sub_items) ||
        currSItem?.sub_items?.length === 0 ? (
          <DataNotFound />
        ) : (
          <>
            <div className="tcl-raffles-items-step">
              <p>Steps</p>
              <ol>
                {currSItem?.sub_items?.map((item, index) => (
                  <li key={index}>{item?.description}</li>
                ))}
              </ol>
            </div>
            <div
              className="tap-to-start"
              onClick={() =>
                navigate(routes.companyReportStages, {
                  state: {
                    ...location.state,
                    showUpload: showUpload,
                    selectedItem: currSItem,
                    selectedLocation: selectedLocation,
                    selectedRestaurant: currSRestaurant,
                  },
                })
              }
            >
              TAP TO START
            </div>
            <div className="d-flex justify-content-center mt-5">
              {currSubItem && (
                <AppButton
                  title="NO SIPHONING"
                  isBtnRed={true}
                  onClick={() => handleSkipSiphoning()}
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CompanyItemDetails;
